import { ActionTree } from 'vuex';
import { NoResultsState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { GetFallbackFiltersResultsAction } from './actions/get-fallback-filters-results.action';

export const NO_RESULTS_ACTIONS: ActionTree<NoResultsState, RootStoreState> = {
  ...new GetFallbackFiltersResultsAction().actions
};
